<template>
  <el-dialog width="500px" :visible="visible" @close="closeHandler" :modal-append-to-body="false">
    <el-form class="info-form" label-width="135px">
      <el-form-item :label="$t('loginName')" prop="username">
        <el-input :value="user.username" readonly></el-input>
      </el-form-item>
      <el-form-item :label="$t('name')" prop="username">
        <el-input :value="user.name" readonly></el-input>
      </el-form-item>
      <el-form-item :label="$t('orgNames')" prop="orgNames">
        <el-input :value="user.orgNames" readonly></el-input>
      </el-form-item>
      <el-form-item :label="$t('role')" prop="email">
        <el-input :value="user.roleName" readonly></el-input>
      </el-form-item>
      <el-form-item :label="$t('phone')" prop="phone">
        <el-input :value="user.phone" readonly></el-input>
      </el-form-item>
      <el-form-item :label="$t('name')" prop="email">
        <el-input :value="user.email" readonly></el-input>
      </el-form-item>
    </el-form>
    <el-form class="info-form" v-show="changePasswordVisible" ref="changePasswordForm" label-width="135px"
             :model="changePasswordForm"
             :rules="changePasswordRules">
      <el-form-item :label="$t('oldPwd')" prop="oldPwd">
        <el-input show-password v-model="changePasswordForm.oldPwd" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('newPwd')" prop="password">
        <el-input show-password v-model="changePasswordForm.password" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('confirmPwd')" prop="password2">
        <el-input show-password v-model="changePasswordForm.password2" clearable></el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: center">
      <el-button v-show="!changePasswordVisible" @click="changePasswordVisible = !changePasswordVisible">
        {{$t("editPassword")}}
      </el-button>
      <el-button v-show="changePasswordVisible" @click="changePasswordVisible = !changePasswordVisible">
        {{$t("cancel")}}
      </el-button>
      <el-button v-show="changePasswordVisible" type="primary" icon="el-icon-folder" :loading="changePasswording"
                 @click="changePassword">
        {{$t("save")}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {changePassword} from "@/api/remote.js";

  export default {
    name: "UserInfoDialog",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
    },
    data() {
      let checkPassword = (rule, password2, callback) => {
        if (this.changePasswordForm.password === password2) {
          return callback();
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          return callback("两次输入密码不一致");
        }
      };
      return {
        changePasswordVisible: false,
        changePasswordForm: {
          oldPwd: null,
          password: null,
          password2: null,
        },
        changePasswordRules: {
          oldPwd: [
            {required: true, message: '', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '', trigger: 'blur'},
          ],
          password2: [
            {required: true, message: '', trigger: 'blur'},
            {validator: checkPassword, trigger: 'blur'},
          ],
        },
        changePasswording: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.userInfo;
      },
    },
    methods: {
      closeHandler() {
        this.$emit('update:visible', false);
      },
      changePassword() {
        this.$refs.changePasswordForm.validate().then(() => {
          this.changePasswordForm.username = this.user.username;
          this.changePasswording = true;
          changePassword(this.changePasswordForm).then(() => {
            this.changePasswordVisible = false;
            this.changePasswording = false;
            sessionStorage.clear();
            this.$router.replace("/login");
          }, () => {
            this.changePasswording = false;
          });
        });
      },
    }
  }
</script>

<style scoped>

</style>
